import type { Address, User } from "shared-components";
import { clientDelete, clientGet, clientPatch, clientPost } from "../client";
import type { UpdateProfileRequest } from "./models";

export async function getProfile(): Promise<User> {
  return await clientGet<User>({ path: "me" });
}

export async function changePassword({
  currentPassword,
  newPassword,
}: {
  currentPassword: string;
  newPassword: string;
}): Promise<User> {
  return clientPatch({
    path: "me/password",
    payload: {
      currentPassword,
      password: newPassword,
    },
  });
}

export async function updateProfile(payload: UpdateProfileRequest): Promise<User> {
  return clientPatch({
    path: "me",
    payload,
  });
}

export const createUserMainAddress = async (payload: Address): Promise<Address> => {
  return clientPost({
    path: "me/address",
    payload,
  });
};

export const updateUserMainAddress = async (payload: Address): Promise<Address> => {
  return clientPatch({
    path: "me/address",
    payload,
  });
};

export const deleteUserMainAddress = async (): Promise<void> => {
  return clientDelete({ path: "me/address" });
};

export const deleteUser = async (payload: {
  password: string;
}): Promise<void | { error: { message: string } }> => {
  return clientDelete({ path: "me", payload });
};

export const exportUserData = async (): Promise<void> => {
  const { fetchFromBase } = await import("../fetchFromBase");

  const response = await fetchFromBase("me/export", {
    method: "GET",
  });

  if (!response.ok) {
    throw new Error("Erro ao exportar dados do usuário");
  }

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "meus-dados.pdf";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};
